// import node module libraries
import { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';

// import custom components
import ApexCharts from 'components/elements/charts/ApexCharts';

// import translations
import { useTranslation } from 'react-i18next';

const OverallProgressChart = ({item}) => {
	const { t } = useTranslation();

	const [progress, setProgress] = useState(
		item && item.config_value && item.config_value.progress !== undefined
			? item.config_value.progress
			: 0
	);

	const theme = {
		primary: 'var(--geeks-primary)',
		secondary: 'var(--geeks-secondary)',
		success: 'var(--geeks-success)',
		info: 'var(--geeks-info)',
		warning: 'var(--geeks-warning)',
		danger: 'var(--geeks-danger)',
		dark: 'var(--geeks-dark)',
		light: 'var(--geeks-light)',
		white: 'var(--geeks-white)',
		gray100: 'var(--geeks-gray-100)',
		gray200: 'var(--geeks-gray-200)',
		gray300: 'var(--geeks-gray-300)',
		gray400: 'var(--geeks-gray-400)',
		gray500: 'var(--geeks-gray-500)',
		gray600: 'var(--geeks-gray-600)',
		gray700: 'var(--geeks-gray-700)',
		gray800: 'var(--geeks-gray-800)',
		gray900: 'var(--geeks-gray-900)',
		black: 'var(--geeks-black)',
		lightPrimary: 'var(--geeks-light-primary)',
		lightSecondary: 'var(--geeks-light-secondary)',
		lightSuccess: 'var(--geeks-light-success)',
		lightDanger: 'var(--geeks-light-danger)',
		lightWarning: 'var(--geeks-light-warning)',
		lightInfo: 'var(--geeks-light-info)',
		darkPrimary: 'var(--geeks-dark-primary)',
		darkSecondary: 'var(--geeks-dark-secondary)',
		darkSuccess: 'var(--geeks-dark-success)',
		darkDanger: 'var(--geeks-dark-danger)',
		darkWarning: 'var(--geeks-dark-warning)',
		darkInfo: 'var(--geeks-dark-info)',
		transparent: 'transparent',
		borderColor: 'var(--geeks-border-color)'
	};

	const OverallProgressChartOptions = {
		chart: { height: 350, type: 'radialBar', toolbar: { show: false } },
		colors: [theme.secondary, theme.primary],
		plotOptions: {
			radialBar: {
				startAngle: -135,
				endAngle: 225,
				hollow: {
					margin: 0,
					size: '70%',
					background: theme.white,
					image: undefined,
					imageOffsetX: 0,
					imageOffsetY: 0,
					position: 'front',
					dropShadow: {
						enabled: true,
						top: 3,
						left: 0,
						blur: 4,
						opacity: 0.24
					}
				},
				track: {
					background: theme.white,
					strokeWidth: '67%',
					margin: 0, // margin is in pixels
					dropShadow: {
						enabled: true,
						top: -3,
						left: 0,
						blur: 4,
						opacity: 0.35
					}
				},
	
				dataLabels: {
					showOn: 'always',
					name: {
						show: false
					},
					value: {
						formatter: function (val) {
							return parseInt(val) + '%';
						},
						color: theme.dark,
						fontSize: '48px',
						fontWeight: '700',
						show: true
					}
				}
			}
		},
		fill: {
			type: 'gradient',
			gradient: {
				shade: 'dark',
				type: 'horizontal',
				shadeIntensity: 0.5,
				gradientToColors: [theme.primary],
				inverseColors: false,
				opacityFrom: 1,
				opacityTo: 1,
				stops: [0, 100]
			}
		},
		stroke: {
			lineCap: 'round'
		}
	};

	// Update status when item changes
	useEffect(() => {
		if (item && item.config_value && item.config_value.progress !== undefined) {
			setProgress(item.config_value.progress);
		}
	}, [item]);

	return (
		<Card className="mb-4">
			<Card.Body>
				<h4 className="mb-3">{t('Overall Configuration Progress')}</h4>
				<ApexCharts
					options={OverallProgressChartOptions}
					series={[progress]}
					type="radialBar"
					height={350}
				/>
			</Card.Body>
		</Card>
	);
};
export default OverallProgressChart;
